import { IBoundingBox } from '../interfaces/geo';

export const mapboxBoundsToRutilusBounds = (bounds: any): IBoundingBox => ({
  southWest: { latitude: bounds.getSouthWest().lat, longitude: bounds.getSouthWest().lng },
  northEast: { latitude: bounds.getNorthEast().lat, longitude: bounds.getNorthEast().lng },
});

// [minX, minY, maxX, maxY]
export const turfBoundsToRutilusBounds = (
  bounds: [number, number, number, number] | [number, number, number, number, number, number],
): IBoundingBox => ({
  southWest: { latitude: bounds[1], longitude: bounds[0] },
  northEast: { latitude: bounds[3], longitude: bounds[2] },
});
